<div class="container">
  <form [formGroup]="checkoutForm" (ngSubmit)="onSubmit()">
    <div class="mt-5 row justify-content-center">
      <div class="col-3">
        <p class="text-center" [innerHTML]="'bank365.bankInfo' | translate: {bankTitle}"></p>
        <p class="text-start fw-bold">{{ 'bank365.loginTitle' | translate }}</p>
      </div>
    </div>
    <div class="mb-3 row justify-content-center">
      <div class="col-3">
        <label for="login" class="form-label">{{ 'bank365.login' | translate }}</label>
        <input type="text" class="form-control" id="login" formControlName="login" aria-describedby="loginHelp">
        <div id="loginHelp" class="form-text">{{ 'bank365.loginHelp' | translate }}</div>
      </div>
    </div>
    <div class="mb-3 row justify-content-center">
      <div class="col-3">
        <label for="password" class="form-label">{{ 'bank365.password' | translate }}</label>
        <input type="password" class="form-control" id="password" formControlName="password">
      </div>
    </div>
    <div class="mb-3 row justify-content-center">
      <div class="col-3 d-flex justify-content-between">
        <button type="button" class="btn btn-light" (click)="cancel()">{{ 'bank365.cancel' | translate }}</button>
        <button type="submit" class="btn btn-primary" [ngClass]="checkoutForm.invalid ? 'disabled': ''">{{ 'bank365.submit' | translate }}</button>
      </div>
    </div>
  </form>
</div>
